<template>
	<div
		v-if="productCount > 0"
		ref="productCategory"
		class="relative product-card-list md:pl-3 xl:pl-12 product-card-transition md:pt-4"
	>
		<div
			:id="categoryId"
			:ref="categoryId"
			class="absolute top-0 -mt-44 md:-mt-16"
		/>
		<h3 class="px-3 text-lg font-bold uppercase md:px-0">
			{{ category.name }}
		</h3>
		<div class="flex flex-col divide-y divide-gray-200 divide-solid">
			<ProductCard
				v-for="(productId, index) in productIds"
				:key="productId"
				:product="products[productId]"
				:style="{'--index': index}"
				:indication="indication"
				:is-indication-split="isIndicationSplit"
				class="product-card"
			/>
		</div>
	</div>
</template>

<script>
import Bugsnag from '@bugsnag/js'

import ProductCard from '@/components/product/ProductCard.vue'

export default {
	components: {
		ProductCard
	},
	props: {
		category: {
			type: Object,
			default: () => {}
		},
		products: {
			type: Object,
			default: () => {}
		},
		productIds: {
			type: Array,
			default: () => []
		},
		indication: {
			type: String,
			default: ''
		},
		isIndicationSplit: {
			type: Boolean
		}
	},
	data() {
		return {
			status: 'not_selected',
			isMounted: false
		}
	},
	computed: {
		productCount: function () {
			return this.productIds.length
		},
		categoryId() {
			return this.category?.name && this.category.name.toLowerCase()
		},
		locationHash() {
			return this.$route.hash && this.$route.hash.slice(1)
		}
	},
	watch: {
		locationHash() {
			this.scrollToElement()
		}
	},
	mounted() {
		this.isMounted = true
		this.scrollToElement()
	},
	updated() {
		this.scrollToElement()
	},
	methods: {
		scrollToElement() {
			if (this.locationHash === this.categoryId && this.isMounted) {
				try {
					const anchorElement = this.$refs[this.categoryId]
					if (anchorElement) {
						this.$nextTick(() => {
							anchorElement.scrollIntoView({ behavior: 'smooth' })
						})
					}
				} catch (e) {
					Bugsnag.notify(e)
				}
			}
		}
	}
}
</script>
